(() => {
  if (window.jmProductMenuReady) return;
  window.jmProductMenuReady = true;
  function activate(event) {
    const link = event.target.closest('.jm-product-menu__category');
    if (!link) return;
    const root = link.closest('.jm-product-menu');
    root.querySelectorAll('.jm-product-menu__category').forEach(item => item.classList.toggle('is-selected', item === link));
    root.querySelectorAll('.jm-product-menu__panel').forEach(panel => { panel.hidden = panel.id !== link.dataset.productPanel; });
  }
  document.addEventListener('pointerover', activate);
  document.addEventListener('focusin', activate);
})();
